export enum ICONS {
  logo = 'logo',
  logo_vertical = 'logo_vertical',
  twitter = 'twitter',
  linkedin = 'linkedin',
  github = 'github'
}
